export default __webpack_public_path__ + "static/media/gallery-36.df7b2d80.jpg";